<template>
  <div class="container">
    <div class="user-group" v-if="list.length>0">
      <van-grid :column-num="2" gutter="3vw" class="clerk-grid">
        <van-grid-item
          @click="onClick(goods.employeeStatus)"
          v-for="goods in list"
          :key="goods.employeeStatus"
        >
          <!-- 不确定是否有小于0的员工状态要显示 -->
          <div class="flex">
            <div class="image" v-if="goods.employeeStatus == 2">
              <img src="../../../assets/images/platform.png" alt />
            </div>
            <div class="image" v-if="goods.employeeStatus == 6">
              <img src="../../../assets/images/clerk.png" alt />
            </div>
            <div class="image" v-if="goods.employeeStatus == 4">
              <img src="../../../assets/images/shopOwner.png" alt />
            </div>

            <div
              class="image"
              v-if="
                goods.employeeStatus == '3,5' ||
                goods.employeeStatus == 5 ||
                goods.employeeStatus == 3
              "
            >
              <img src="../../../assets/images/unreviewed.png" alt />
            </div>
            <div class="text">
              <div class="bold">{{ goods.total }}</div>
              <div class="gray">
                {{ getChineseStatus(goods.employeeStatus) }}
              </div>
            </div>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    <div v-else class="index-empty">
      <div class="imageEmptySearch">
        <img src="../../../assets/images/search.png" alt />
      </div>
      您还没有店员...
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  Dialog,
  Grid,
  GridItem,
  Image,
  Overlay,
} from "vant";
import service from "../../api/userCenterPage/userCenterPage";
import loading from "../../components/loading/loading";
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Dialog.name]: Dialog,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image,
    [Overlay.name]: Overlay,
    loading
  },
  data() {
    return {
      isLoading:true, //loading状态
      list: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    getChineseStatus(StatusText) {
      // switch (StatusText) {
      //   case 0:
      //     return "平台审核中";
      //   case 1:
      //     return "未通过审核";
      //   case 3:
      //     return "未通过审核";
      //   case "1,3":
      //     return "未通过审核";
      //   case 2:
      //     return "店长审核";
      //   case 4:
      //     return "我的店员";
      //   default:
      //     break;
      // }
      switch (StatusText) {
        case 2:
          return "平台审核中";
        case 3:
          return "未通过审核";
        case 5:
          return "未通过审核";
        case "3,5":
          return "未通过审核";
        case 4:
          return "店长审核";
        case 6:
          return "我的店员";
        default:
          break;
      }
    },
    init() {
      service.getNum().then((res) => {
        this.isLoading =false
        var arr = [];
        var arr3 = [];
        var arry = [];
        var total = 0;
        var totalArr = [];
        arr3 = res.data.filter(
          (item) => item.employeeStatusId == 5 || item.employeeStatusId == 3
        );
        if (arr3.length == 2) {
          arr3.map((i) => {
            total += i.total;
          });
          arry = [
            {
              employeeStatusId: "3,5",
              total: total,
            },
          ];
          arr = res.data.filter(
            (item) => item.employeeStatusId !== 5 && item.employeeStatusId !== 3
          );
          totalArr = arry.concat(arr);
          this.list = totalArr;
        } else {
          this.list = res.data;
        }
      });
    },
    onClick(id) {
      this.$router.push({ name: "managerList", query: { id: id } });
    },
  },
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.container {
  height: calc(100% - 46px);
  // background: #f4f4f4;
  @{deep} .van-grid-item__content {
    flex-direction: row;
    padding: 2vw 2.13333vw;
  }
  @{deep} .van-grid-item__content--center {
    justify-content: flex-start;
    box-shadow: 0px 0px 6px 0px rgba(2, 16, 0, 0.1);
    border-radius: 5px;
  }
  .flex {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .image {
    width: 32px;
    height: 32px;
    margin: 0 3.6vw 0 2vw;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .van-grid-item {
    height: 100px;
  }
  .clerk-grid {
    padding-top: 3vw;
  }
  .manganerPic {
    width: 32px;
    height: 32px;
    padding: 0 3vw;
  }
  .bold {
    font-size: 18px;
    font-weight: bold;
  }
  .gray {
    color: #a6a6a6;
    padding-top: 2vw;
  }
  .list {
    display: flex;
    justify-content: space-between;
    padding: 0 2vw;
    height: 100px;
  }
  .every {
    display: flex;
    margin: 0 1vw;
    background: #fff;
    width: 50%;
    align-items: center;
    box-shadow: 0px 0px 13px 0px rgba(2, 16, 0, 0.1);
    border-radius: 10px;
  }
}
</style>